


















import BaseComponent from "@/core/base.component";
import { Component } from "vue-property-decorator";

@Component({
  name: 'Renewal',
})
export default class Renewal extends BaseComponent {
	
	
}
